var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDexpay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8158 3.33105H23.6748V40.929H25.8158V3.33105Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8115 11.2793H29.9526V49.9964H27.8115V11.2793Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8158 11.2793H23.6748V13.9556H25.8158V11.2793ZM27.8109 13.9556H30.5601C33.673 13.9556 36.1966 16.4791 36.1966 19.592C36.1966 22.705 33.673 25.2285 30.5601 25.2285H23.6748V27.9047H30.3007C34.8917 27.9047 38.6134 24.1831 38.6134 19.592C38.6134 15.001 34.8917 11.2793 30.3007 11.2793H27.8109V13.9556Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9523 25.2285H23.3264C18.7354 25.2285 15.0137 28.9502 15.0137 33.5412C15.0137 38.1322 18.7354 41.854 23.3264 41.854H25.8162V39.1776H23.0668C19.9539 39.1776 17.4304 36.6541 17.4304 33.5412C17.4304 30.4282 19.9539 27.9047 23.0668 27.9047H29.9523V25.2285ZM27.8113 39.1776V41.854H29.9523V39.1776H27.8113Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4313 0.314713C25.5495 0.196525 25.6789 0.0964692 25.8162 0.0145465V4.11429L3.36741 26.563L25.8323 49.0279V53.121C25.6891 53.0374 25.554 52.9342 25.4313 52.8113L0.577755 27.9578C-0.192585 27.1875 -0.192586 25.9385 0.577755 25.1682L25.4313 0.314713ZM27.8274 53.1165C27.9678 53.0336 28.1002 52.9318 28.2209 52.8113L53.0743 27.9578C53.8448 27.1875 53.8448 25.9385 53.0743 25.1682L28.2209 0.314711C28.0957 0.189434 27.9576 0.0845306 27.8112 0V4.0895L50.2846 26.563L27.8274 49.0202V53.1165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDexpay);
export default __webpack_public_path__ + "static/media/logoDexpay.75ef5f94223f577e730af8119cffd16e.svg";
export { ForwardRef as ReactComponent };